import { useConfig } from "@/app/composables/useConfig"
import { useCurrencies } from "@/app/composables/useCurrencies"
import { useReferAndEarn } from "@/app/composables/useReferAndEarn.js"
import { useUserService } from "@/user-account/composables/useUserService"
import { useBetStore } from "../../../store"
import { ping } from "../api"
import { useBonuses } from "../composables/useBonus"
import { useFreeSpins } from "../composables/useFreeSpins"
import { useLogoBanner } from "../composables/useLogoBanner"
import { useMaintenance } from "../composables/useMaintenance"
import { useNavigation } from "../composables/useNavigations"
import { useTimeServer } from "../composables/useTimeServer"

const { setCurrencies } = useCurrencies()
const { setUser } = useUserService()
const { setSystemSettings, setRegistrationFlow, setBtcRate, setFiles } = useConfig()
const { setBanners, setLogo, setPromoBanner } = useLogoBanner()
const { setNavigation } = useNavigation()
const { setTimeServer } = useTimeServer()
const { setReferAndEarn } = useReferAndEarn()
const { setBonuses } = useBonuses()
const { setMaintenance } = useMaintenance()
const { setFreeSpins } = useFreeSpins()

function getCookie(cname) {
  const name = `${cname}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(";")
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === " ") {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ""
}

async function pingServer() {
  const query = [
    "systemSettings",
    "currencies",
    "sports",
    "userAccount",
    "freeBets",
    "freeSpins",
    "virtualGames",
    "registrationFlow",
  ]
  const { setNotifications } = useBetStore()

  if (query.length > 0) {
    const newData = await ping()

    const settings = newData.data.settings

    setSystemSettings(settings)

    setRegistrationFlow(settings.registrationFlow)

    setMaintenance(settings.isMaintenanceMode)

    setBtcRate(newData.data.btc_usd_rate)

    if (newData.data.files) {
      setFiles(newData.data.files)
    }

    setReferAndEarn(settings.referAndEarn)

    setCurrencies(newData.data.currencies)

    const logo = newData.data.banners.find(banner => banner.type === "logo")
    const promoBanner = newData.data.banners.find(banner => banner.type === "bonus-promo")

    setLogo(logo)

    setPromoBanner(promoBanner)

    setTimeServer(newData.data.now)

    if (newData.data?.user) {
      setUser(newData.data?.user)
    }
    setBanners(newData.data.banners)

    setFreeSpins(newData.data.freeSpins)
    setBonuses(newData.data.userBonuses ?? [])

    setNavigation([])

    setNotifications(newData.data.notifications)
  }
}

async function initPingService() {
  await pingServer()

  if (import.meta.env.VITE_PING === "true") {
    setInterval(async () => {
      await pingServer()
    }, 3000)
  }
}

export { getCookie, initPingService, pingServer }
